import { __assign, __rest } from "tslib";
import React from 'react';
import { Typography as MaterialTypography, makeStyles, createStyles, } from '@material-ui/core';
var useStyles = makeStyles(function (theme) {
    return createStyles({
        // TODO: fix the typing
        root: function (_a) {
            var variant = _a.variant;
            return (__assign({}, theme.typography[variant]));
        },
    });
});
/** @deprecated Please use the [Headline] component instead.*/
export var Heading = function (_a) {
    var children = _a.children, className = _a.className, _b = _a.variant, variant = _b === void 0 ? 'h1' : _b, props = __rest(_a, ["children", "className", "variant"]);
    var classes = useStyles({ variant: variant });
    return (React.createElement(MaterialTypography, __assign({ classes: classes, className: className }, props), children));
};
//# sourceMappingURL=Heading.js.map